export const WorkData = [
  {
    company: "Gs1ng - Software Developer",
    designation: "W",
    dateJoining: "2022 ",
    dateEnd: "  Present",
    companyLogo:
      "https://gs1ng.org/img/GS1_Nigeria_61px_Tall_RGB_2014-12-17.png",
    work: "Working as a software developer, Offered experience working with client-server architectures, networking protocols, and databases",
  },
  {
    company: "Delsu Investment Limited",
    designation: "IT Support",
    dateJoining: "2020",
    dateEnd: "2021",
    companyLogo: "#",
    work: "Providing technical support and ensuring the whole company runs smoothly also monitors and maintains the company computer systems, installs, and configures hardware and software, and solves technical issues as they arise",
  },

  {
    company: "Web Developer Freelaner",
    designation: "Web developer",
    dateJoining: "2019",
    dateEnd: "Present",
    companyLogo: "https://cdn-icons-png.flaticon.com/512/2537/2537338.png",
    work: "Build and construct scalable web app from home",
  },
];